import { createContentPropTypes } from '../../../helpers/content';

const importPayeesContent = {
	header: 'Imported payee entries',
	subHeader1: 'Please check the imported entries are correct before you continue.',
	subHeader2:
		"We'll check for existing payees and any problems with their account details before we add them to your list.",
	continueButtonText: 'Continue',
	tableHeader: [
		{ title: 'Payee Name', path: ['name'] },
		{ title: 'Nickname', path: ['display_name'] },
		{ title: 'Sort code', path: ['sort_code'] },
		{ title: 'Account number', path: ['account_number'] },
		{ title: 'Reference', path: ['reference'] },
	],
	successMessage: 'Your payees have been successfully added to your payee list.',
	fileUploadUnfinishedContent: {
		title: 'Are you sure you want to cancel?',
		textBody: 'If you cancel now, any payees you’ve imported won’t be saved.',
		destructiveActionButtonText: 'Yes, cancel',
		safeActionButtonText: 'No, go back',
	},
	footer: "That's all of them.",
};

export const contentPropTypes = createContentPropTypes(importPayeesContent);

export default importPayeesContent;
